import React, { useState, useReducer, useEffect } from "react";
import { Button, Grid, Form, Modal, Icon, Dropdown } from "semantic-ui-react";
import {
  initialState,
  reducer,
  ACTION,
} from "../../../Reducer/InitialStateReducer";

import { server } from "../../../App";
import axios from "axios";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { DureeOptions } from "./DropdownOptions/DureeOptions";
import CheckboxRenderer from "./CheckboxRenderer";
import moment from "moment";

function Medicaments(props) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [, setGridApi] = useState(null);
  const [, setGridColumnApi] = useState(null);
  const [NewDureeOptions, set_Duree_Options] = useState(DureeOptions);
  const [, set_ordonnance_date] = useState("");

  const { ID, objectToSend, refreshOrdonnances } = props;

  // console.log(AuthState);

  // let rows, rdv, ordonnance_date3;
  // rows = state.rowData2;
  // rdv = state.rdv;
  // ordonnance_date3 = state.ordonnance_date3;

  const handleAddition_duree = (e, { value }) => {
    set_Duree_Options((prevState) => [
      { key: value + Date.now(), text: value, value },
      ...prevState,
    ]);
  };

  const columnDefs2 = [
    {
      headerName: "id_ordonnance_medicaments",
      field: "id_ordonnance_medicaments",
      editable: false,
      hide: true,
    },
    {
      // checkboxSelection: true,
      // floatingFilter: true,
      headerName: "Medicament",
      field: "medicament",
    },
    {
      headerName: "Qte",
      field: "qte",
    },
    {
      headerName: "Posologie",
      field: "posologie",
    },
    {
      headerName: "duree",
      field: "duree",
    },

    {
      headerName: "OD",
      field: "od",
      cellRenderer: CheckboxRenderer,
      editable: false,
    },
    {
      headerName: "od bool",
      field: "od",
      hide: true,
    },
    {
      headerName: "OG",
      field: "og",
      cellRenderer: CheckboxRenderer,
      editable: false,
    },
    {
      headerName: "og bool",
      field: "og",
      hide: true,
    },

    // 1ere sous catégorie
  ];

  const defaultColDef2 = {
    sortable: true,
    editable: true,
    cellEditor: "agLargeTextCellEditor",
    maxLength: 255,
    flex: 1,
    // filter stuff
    filter: true,
    // floatingFilter: true,
    // suppressMenu: true,
    // end of filter stuff
    minWidth: 100,
    // resizable: true,
    // tooltipComponent: 'customTooltip',
    filterParams: {
      newRowsAction: "keep",
      // buttons: ['apply', 'clear'],
    },
    resizable: true,
    cellClass: "cell-wrap-text",
    autoHeight: true,
  };

  async function getOneUser() {
    if (objectToSend.rows) {
      // set_ordonnance_date(objectToSend.rows[0].date_ordonance2)
      dispatch({
        type: ACTION.FETCH_SUCCESS2UPDATE,
        payload: objectToSend.rows,
      });
    }
  }

  useEffect(() => {
    getOneUser();
  }, [state.open]);

  // const onValueChanged2 = async () => {
  //   const ss = rows.map((row) => ` ${row.medicament}`);

  //   const cellValue = ss.toString();

  //   const ValuesToCreate = {
  //     fk_id_patientConsul: ID,
  //     created_by: AuthState.user_name,
  //     od: cellValue,
  //     // od: state.od,
  //     fk_id_examen: 15,
  //     // observation: state.observation
  //   };

  //   axios({
  //     method: "post",
  //     responseType: "json",
  //     url: `${server}Consultation`,
  //     data: ValuesToCreate,
  //     headers: {
  //       jwtoken: sessionStorage.token,
  //     },
  //   })
  //     .then((response) => {
  //       syncData(response.data);
  //       refreshOrdonnances();
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       dispatch({ type: ACTION.CREATE_ERROR });
  //     });
  //   onTimeChanged();
  //   onRdvChanged();
  //   dispatch({ type: ACTION.OPEN2, size2: "large" });
  // };

  // const onValueChanged = async () => {
  //   const objectToSend2 = {
  //     rows,
  //     rdv,
  //     date_consultation: ordonnance_date,
  //     userInformation,
  //     idpatient: ID,
  //   };

  //   axios({
  //     method: "post",
  //     responseType: "json",
  //     url: `${server}OrdonanceMedoc`,
  //     data: objectToSend2,
  //     headers: {
  //       jwtoken: sessionStorage.token,
  //     },
  //   })
  //     .then(() => {
  //       // syncData(response.data)
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       dispatch({ type: ACTION.CREATE_ERROR });
  //     });
  // };
  ///////////////////////////////////////////////////////////////////////////////////

  const onGridReady = (params) => {
    setGridColumnApi(params.columnApi);
    setGridApi(params.api);
    params.api.setRowData(state.rowData2);
  };

  const onSelectionChanged2 = (e) => {
    if (e.api.getSelectedRows()[0] === undefined) {
      const emptyCheckbox = {
        id_ordonnance_medicaments: "",
        medicament: "",
        qte: "",
        posologie: "",
        duree: "",
        od: "",
        og: "",
      };
      dispatch({
        type: ACTION.ORDONANCE_MEDICAMENTS,
        value: emptyCheckbox,
      });
    } else {
      let clientArray = e.api.getSelectedRows()[0];
      const allRows = state.rowData2;
      let index = allRows.findIndex((x) => {
        if (
          x.id_ordonnance_medicaments ===
          clientArray.id_ordonnance_medicaments &&
          x.medicament === clientArray.medicament &&
          x.qte === clientArray.qte &&
          x.posologie === clientArray.posologie &&
          x.duree === clientArray.duree &&
          x.od === clientArray.od &&
          x.og === clientArray.og
        ) {
          return true;
        }
      });

      let ModclientArray = {
        ...clientArray,
        index: index,
      };

      dispatch({
        type: ACTION.ORDONANCE_MEDICAMENTS,
        value: ModclientArray,
      });
    }
  };

  const onCellValueChanged2 = async ({ data }) => {
    axios({
      method: "put",
      responseType: "json",
      url: `${server}OrdonanceMedoc/UpdateOrdonance`,
      data: data,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then(() => {
        refreshOrdonnances();
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };
  const onTimeChanged = async () => {
    if (objectToSend.rows) {
      const data = {
        New_date_ordonance: state.ordonnance_date3,
        Old_date_ordonance: objectToSend.rows[0].date_ordonance2,
        fk_id_patient1: ID,
      };

      axios({
        method: "put",
        responseType: "json",
        url: `${server}OrdonanceMedoc/UpdateOneUserdate_ordonance`,
        data: data,
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
        .then(() => {
          refreshOrdonnances();
        })
        .catch((err) => {
          console.log(err);
          dispatch({ type: ACTION.CREATE_ERROR });
        });
    }
  };

  const onRdvChanged = async () => {
    if (objectToSend.rows) {
      const data = {
        New_rdv: state.rdv,
        Old_rdv: objectToSend.rows[0].rdv,
        fk_id_patient1: ID,
        ordonnance_date3: state.ordonnance_date3,
      };

      axios({
        method: "put",
        responseType: "json",
        url: `${server}OrdonanceMedoc/UpdateOneUserRDV_ordonance`,
        data: data,
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
        .then(() => {
          refreshOrdonnances();
        })
        .catch((err) => {
          console.log(err);
          dispatch({ type: ACTION.CREATE_ERROR });
        });
    }
  };

  const handleRemoveItem1 = async () => {
    // dispatch({ type: ACTION.FETCH_SUCCESS2Mod2 })

    axios({
      method: "DELETE",
      responseType: "json",
      url: `${server}OrdonanceMedoc/DeleteOneUserOrdonnanceItem/${state.id_ordonnance_medicaments}/${state.ordonnance_date3}/${ID}`,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        // dispatch({ type: ACTION.DELETE_SUCCESS })
        // getOneUser()

        dispatch({ type: ACTION.FETCH_SUCCESS2, payload: response.data });
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };

  // let content, attributes;
  // if (objectToSend.rows) {
  //   // attributes = objectToSend.rows[0];
  //   content = state?.rowData2?.map(
  //     (row, i) =>
  //       `<p class="mceNonEditable" style="padding-left: 2rem;line-height: 1;"><span style="text-decoration: underline;"><strong>
  //         ${i + 1}/
  //         ${row.medicament} ${
  //         row.od
  //           ? row.og
  //             ? " - Les Deux Yeux"
  //             : " - Oeil Droit"
  //           : row.og
  //           ? " - Oeil Gauche"
  //           : ""
  //       }
  //         ${row.qte ? `- ${row.qte}` : ""}
  //         </strong></span></p>
  //       <p class="mceNonEditable" style="padding-left: 3rem;">
  //         ${row.posologie ? row.posologie : ""}, ${row.duree ? row.duree : ""}
  //       </p>`
  //   );
  // }

  // let headerDate = `<h4 class="mceNonEditable" style="text-align: right;">${
  //   state.ordonnance_date3 ? `Le ${state?.ordonnance_date3}` : ""
  // }</h4>`;
  // let headerName = `<h4 class="mceNonEditable" style="text-align: center; margin: 2.5rem;">${userInformation?.civilite} ${userInformation?.nom} ${userInformation?.prenom}</h4>`;

  // let rdvFooter = `<p style="padding-left: 2rem;line-height: 1;" class="mceNonEditable">${
  //   state?.rdv ? `Prochain rendez-vous dans ${state?.rdv}` : ""
  // }</p>`;

  // if (content) {
  //   content = content?.join(" ").toString();
  // } else {
  //   content = "";
  // }

  // let description = headerDate + headerName + content + rdvFooter;

  useEffect(() => {
    if (state.ordonnance_date3) {
      onTimeChanged();
      // console.log("date changed maybe");
      // setContent(description);
    }
  }, [state.ordonnance_date3]);
  useEffect(() => {
    if (state.rdv) {
      onRdvChanged();
      // console.log("RDV changed maybe");
      // setContent(description);
    }
  }, [state.rdv]);
  // useEffect(() => {
  //   // if (state.rowData2) {
  //   console.log("rowData2");
  //   // setContent(description);
  //   // }
  // }, [state.rowData2]);

  // console.log(state);

  // let Contents = (
  //   <div>
  //     <Editor
  //       // apiKey="4wmks1hxrd175lnu674946w8nb95pzv263exeq2v73z02al0"
  //       tinymceScriptSrc={process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"}
  //       onInit={(evt, editor) => (editorRef.current = editor)}
  //       initialValue={Content}
  //       init={{
  //         // selector: "textarea",
  //         branding: false,
  //         height: "70vh",
  //         menubar: false,
  //         noneditable_editable_class: "mceEditable",
  //         plugins: [
  //           "advlist autolink lists link image charmap print preview anchor",
  //           "searchreplace visualblocks code fullscreen",
  //           "insertdatetime media table paste code help ",
  //           "print",
  //           "noneditable",
  //         ],
  //         toolbar: " print  ",
  //         content_style:
  //           "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
  //         setup: function (editor) {
  //           editor.on("keydown", function (event) {
  //             if (event.keyCode === 8 || event.keyCode === 46) {
  //               const currentLine = editor.selection.getNode();

  //               // Prevent deletion of non editable text
  //               if (
  //                 currentLine.hasAttribute("data-mce-bogus") ||
  //                 currentLine.className.includes("mceNonEditable")
  //               ) {
  //                 event.preventDefault();
  //                 event.stopPropagation();
  //                 return false;
  //               }
  //             }
  //           });
  //         },
  //       }}
  //     />
  //   </div>
  // );

  useEffect(() => {
    let date_ordonnance_medicaments = moment().format("YYYY-MM-DD");
    set_ordonnance_date(date_ordonnance_medicaments);
  }, []);
  // let componentToShow;
  // if (state.rowData2 && state?.rowData2?.length > 0) {
  //   componentToShow = (
  //     <>
  //       {/* <Button
  //               // floated="left"
  //               onClick={() => dispatch({ type: ACTION.OPEN2, size2: 'large' })} primary>
  //               Imprimer<Icon className="leftSpace" name='print' />
  //           </Button> */}
  //       {/* <Button positive onClick={onTimeChanged}>
  //               <Icon className="leftSpace" name='save' />
  //           </Button> */}
  //       <Button positive onClick={onValueChanged2}>
  //         Valider <Icon className="leftSpace" name="check circle" />
  //       </Button>
  //     </>
  //   );
  // } else {
  //   componentToShow = (
  //     <>
  //       {/* <Button
  //               disabled
  //               onClick={() => dispatch({ type: ACTION.OPEN2, size2: 'large' })} primary>
  //               Imprimer<Icon className="leftSpace" name='print' />
  //           </Button>
  //           <Button disabled positive onClick={onValueChanged}>
  //               Archiver ordonnace <Icon className="leftSpace" name='save' />
  //           </Button> */}
  //       <Button disabled positive>
  //         Valider <Icon className="leftSpace" name="check circle" />
  //       </Button>
  //     </>
  //   );
  // }

  return (
    <>
      {/* edit */}
      <Button
        color="blue"
        onClick={() => dispatch({ type: ACTION.OPEN, size: "fullscreen" })}
      >
        <Icon name="edit" className="centerIcon" />
      </Button>
      <Modal
        size={state.size}
        open={state.open}
        onClose={() => dispatch({ type: ACTION.CLOSE })}
        className="lunettesModal"
      >
        <Modal.Header className="center3columnheaders">
          {/* <Modal
            onClose={() => dispatch({ type: ACTION.CLOSE2 })}
            size={state.size2}
            open={state.open2}
          >
            <Modal.Header>Ordonnnance</Modal.Header>
            <Modal.Content>{Contents}</Modal.Content>
            <Modal.Actions>
              <Button
                icon="reply"
                content="Retour"
                onClick={() => dispatch({ type: ACTION.CLOSE2 })}
              />
            </Modal.Actions>
          </Modal> */}
          <Grid>
            <Grid.Column width={2}>
              <Form size="small">
                <Form.Field
                  // inline={true}
                  value={state.rdv}
                  onAddItem={handleAddition_duree}
                  search
                  selection
                  fluid
                  allowAdditions
                  // label='Prochain RDV'
                  control={Dropdown}
                  options={NewDureeOptions}
                  placeholder="Prochain RDV"
                  onChange={(e, data) =>
                    dispatch({
                      type: ACTION.ORDONANCE_RDV,
                      payload: data.value,
                    })
                  }
                // onChange={(e, data) => {
                //     set_Od_Val(data);
                // }}
                />
              </Form>
            </Grid.Column>
            {/* <Grid.Column width={2}>
                         
                        </Grid.Column> */}
            <Grid.Column width={10}>Modification d'une Ordonnance</Grid.Column>
            {/* <Grid.Column width={2}>
                            <Button positive onClick={onRdvChanged}>
                                <Icon className="centerIcon" name='save' />
                            </Button>
                        </Grid.Column> */}

            <Grid.Column width={3} floated="right">
              <input
                // key={999}

                type="date"
                defaultValue={state.ordonnance_date3}
                onChange={(e) =>
                  dispatch({
                    type: ACTION.ORDONANCE_dateMod,
                    payload: e.target.value,
                  })
                }
              />
            </Grid.Column>
            {/* <Grid.Column width={2}>
                            <Button positive onClick={onTimeChanged}>
                                <Icon className="centerIcon" name='save' />
                            </Button>
                        </Grid.Column> */}
          </Grid>
        </Modal.Header>
        <Modal.Content>
          <Grid>
            <Grid.Column width={16}>
              <div
                id="myGrid"
                className="ag-theme-alpine"
                style={{
                  height: "64.5vh",
                  width: "100%",
                }}
              >
                <AgGridReact
                  rowData={state.rowData2 ? state.rowData2 : []}
                  // rowData={[]}
                  animateRows={true}
                  sortingOrder={["desc", "asc", null]}
                  onGridReady={onGridReady}
                  columnDefs={columnDefs2}
                  defaultColDef={defaultColDef2}
                  rowSelection={"single"}
                  onSelectionChanged={onSelectionChanged2}
                  undoRedoCellEditing={true}
                  undoRedoCellEditingLimit={40}
                  onCellValueChanged={onCellValueChanged2}
                  enableCellChangeFlash={true}
                  components={{
                    CheckboxRenderer: CheckboxRenderer,
                  }}
                ></AgGridReact>
              </div>
              <br />
              <Grid.Row>
                {state.id_ordonnance_medicaments ? (
                  <>
                    {/* <Button positive onClick={() => UpdateLunettesAttributes()} icon>
                                            <Icon name='save' />
                                        </Button> */}
                    {/* <button onClick={() => onRemoveSelected()}>Remove Selected</button> */}
                    <Button
                      negative
                      onClick={() => handleRemoveItem1()}
                      floated="right"
                      icon
                    >
                      <Icon name="delete" />
                    </Button>
                  </>
                ) : (
                  <>
                    {/* <Button disabled positive onClick={() => UpdateLunettesAttributes()} icon>
                                            <Icon name='save' />
                                        </Button> */}

                    <Button disabled negative floated="right" icon>
                      <Icon name="delete" />
                    </Button>
                  </>
                )}
              </Grid.Row>
            </Grid.Column>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Button color="blue" onClick={() => dispatch({ type: ACTION.CLOSE })}>
            Retour <Icon className="leftSpace" name="reply" />
          </Button>

          {/* {componentToShow} */}
        </Modal.Actions>
      </Modal>
    </>
  );
}

export default Medicaments;
